import * as fromDatatype from "../datatype-library/index";

export interface bl_wms_grn_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    owner_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    owner_comp_guid: fromDatatype.GuidDataFieldInterface;
    owner_branch_guid: fromDatatype.GuidDataFieldInterface;
    wms_item_type: fromDatatype.VarcharDatatypeInterface;
    wms_item_name: fromDatatype.VarcharDatatypeInterface;
    wms_item_code: fromDatatype.VarcharDatatypeInterface;
    wms_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    wms_uom: fromDatatype.VarcharDatatypeInterface;
    wms_qty_base: fromDatatype.NumericDatatypeInterface;
    wms_qty_uom: fromDatatype.NumericDatatypeInterface;
    tracking_id: fromDatatype.VarcharDatatypeInterface;
    fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    item_code: fromDatatype.VarcharDatatypeInterface;
    item_name: fromDatatype.VarcharDatatypeInterface;
    item_type: fromDatatype.VarcharDatatypeInterface;
    item_subtype: fromDatatype.VarcharDatatypeInterface;
    item_uom: fromDatatype.VarcharDatatypeInterface;
    item_qty_base: fromDatatype.NumericDatatypeInterface;
    item_qty_uom: fromDatatype.NumericDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status:  fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    split_qty: fromDatatype.NumericDatatypeInterface;
}

export class bl_wms_grn_line_RowClass
    implements bl_wms_grn_line_RowInterface
{
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    owner_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    owner_comp_guid: fromDatatype.GuidDataFieldInterface;
    owner_branch_guid: fromDatatype.GuidDataFieldInterface;
    wms_item_type: fromDatatype.VarcharDatatypeInterface;
    wms_item_name: fromDatatype.VarcharDatatypeInterface;
    wms_item_code: fromDatatype.VarcharDatatypeInterface;
    wms_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    wms_uom: fromDatatype.VarcharDatatypeInterface;
    wms_qty_base: fromDatatype.NumericDatatypeInterface;
    wms_qty_uom: fromDatatype.NumericDatatypeInterface;
    tracking_id: fromDatatype.VarcharDatatypeInterface;
    fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    item_code: fromDatatype.VarcharDatatypeInterface;
    item_name: fromDatatype.VarcharDatatypeInterface;
    item_type: fromDatatype.VarcharDatatypeInterface;
    item_subtype: fromDatatype.VarcharDatatypeInterface;
    item_uom: fromDatatype.VarcharDatatypeInterface;
    item_qty_base: fromDatatype.NumericDatatypeInterface;
    item_qty_uom: fromDatatype.NumericDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status:  fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    split_qty: fromDatatype.NumericDatatypeInterface;
}